import React from 'react'
import { motion } from "framer-motion";

const CareerHero = () => {
  return (
   <section className="about-hero">

      <div className="hero-container">

        {/* LEFT */}
        <motion.div
          className="hero-left"
          initial={{ opacity: 0, y: 80 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >

          <h2 className="hero_head">
          Your Next Big Opportunity Starts Here
          </h2>

          <p className="hero-text">
          Explore exciting roles, meaningful work, and a culture designed to help you thrive.
          </p>

        </motion.div>

       
        <div className="hero-right">

           <div className="blob">
            <img className="cover-img"
              src="./career-hero.webp"
              alt="team"
              loading='lazy'
            />
          </div>

        </div>

      </div>
    </section>
  )
}

export default CareerHero